import Styles from './UploadsDrawer.module.scss'
import { useUploadsTab } from '../UploadsTabContext'
import { Carousel } from 'components/Carousel/Carousel'
import { useInsertStockVideos } from '../useInsertStockVideos'
import { MediaFile } from '../MediaFile'
import { IMediaFile } from '../Types'
import { getVideoMimeType } from '../components/StockVideosGallery'
import { useRootStore } from 'stores/RootStore'
import { observer } from 'mobx-react-lite'
import { SectionHeader } from './SectionHeader'
import { LoadingCarousel } from './LoadingCarousel'
import { useStockVideos } from 'hooks/queries/designer/useStockVideos'

export const StockVideos = observer(() => {
  const { openPanel } = useUploadsTab()
  const { handleInsert } = useInsertStockVideos()

  const { data, isFetched, isError } = useStockVideos({
    query: '',
    pageSize: 6,
    videoType: 'all',
  })
  const { drawersStore } = useRootStore()

  const videos = data?.pages.flatMap((page) => page.videos) || []

  if ((isFetched && videos.length === 0) || isError) {
    return null
  }

  return (
    <div>
      <SectionHeader
        title="Stock Videos"
        onPress={() => setTimeout(() => openPanel({ panel: 'videos', panelProps: {} }))}
      />
      <div className={Styles.sectionContainer}>
        <Carousel slideGap={7}>
          {!isFetched && <LoadingCarousel />}
          {isFetched &&
            videos.slice(0, 6).map((video, index) => (
              <div key={index} className={Styles.mediaFileContainer}>
                <MediaFile
                  key={video.id}
                  src={video.videos.medium.thumbnail}
                  file={
                    {
                      id: video.id,
                      source_url: video.videos.medium.url,
                      duration: video.duration,
                      variants: [],
                      mime_type: video.videos.medium.mime_type ?? getVideoMimeType(video.videos.medium.url),
                      title: video.id,
                    } as IMediaFile
                  }
                  size={{ height: 100, width: 100 }}
                  onPress={() => {
                    handleInsert(video)
                    drawersStore.closeDrawer()
                  }}
                />
              </div>
            ))}
        </Carousel>
      </div>
    </div>
  )
})
